module.exports = __webpack_public_path__ + "static/media/woman-brush.c4158ac5.png";